import React from 'react';
import { Link } from 'react-router-dom';

import ShippingMethodBanner from 'components/account/ShippingMethodBanner';
import { PROVIDE_LABEL_OPTIONS } from 'constants/exchanges';
import { RETURN_STEPS } from 'constants/returnItemInstructions';
import useMartyContext from 'hooks/useMartyContext';
import PickUpReturnDetails from 'components/account/PickUpReturnDetails';
import { myAccountLinkMap } from 'constants/amethystEnums';

import css from 'styles/components/account/returns/returnsAndExchanges.scss';

export const returnSpecificCopy = labelDelivery => {
  const defaultSteps = RETURN_STEPS[PROVIDE_LABEL_OPTIONS.PRINT];
  return RETURN_STEPS[labelDelivery] ?? defaultSteps;
};

const shouldRenderReturnsAndExchanges = (showReturnsAndExchanges, labelDelivery, copy) =>
  showReturnsAndExchanges && (labelDelivery || Object.keys(copy).length !== 0);

const ReturnsAndExchanges = ({ copy = {}, labelDelivery, UPSPickUpAddress = {}, displayUPSPickUpAddress = false }) => {
  const {
    marketplace: {
      returns: { showReturnsAndExchanges, returnPolicyUrl }
    }
  } = useMartyContext();

  if (!shouldRenderReturnsAndExchanges(showReturnsAndExchanges, labelDelivery, copy)) {
    return null;
  }

  const displayCopy = { ...returnSpecificCopy(labelDelivery), ...copy }; // allow for dynamic copy
  return (
    <div className={css.returnsAndExchanges} data-test-id="returnsAndExchanges">
      <div className={css.returnHeader}>
        <ShippingMethodBanner labelDelivery={labelDelivery} />
        <div className={css.titleAndReturnPolicyLink}>
          <h2>{displayCopy.heading}</h2>
          <p>
            <Link data-amethyst-account-link={myAccountLinkMap.RETURN_POLICY_CLICK} to={returnPolicyUrl || ''}>
              <span className={css.ourReturnPolicy}>{displayCopy.link}</span>
            </Link>
          </p>
        </div>
      </div>
      {displayUPSPickUpAddress && labelDelivery === PROVIDE_LABEL_OPTIONS.PICKUP && (
        <PickUpReturnDetails className={css.address} UPSPickUpAddress={UPSPickUpAddress} />
      )}
      <div className={css.boxes}>
        {(displayCopy.newBoxes || displayCopy.boxes).map(box => (
          <div key={box.title}>
            <h3>{box.title}</h3>
            <div className={css.illustration}>
              <img src={box.img} alt="" />
            </div>
            {/* looking to put this in Symphony and would need to have links rendered from copy passed in */}
            <div dangerouslySetInnerHTML={{ __html: box.description }} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default ReturnsAndExchanges;
